
import { toast } from "@/hooks/use-toast";

/**
 * Creates a downloadable file and triggers download
 */
export const downloadFile = (content: string, fileName: string, contentType: string): void => {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  
  URL.revokeObjectURL(url);
  
  toast({
    title: "Export Successful",
    description: `File '${fileName}' has been downloaded.`,
    duration: 3000,
  });
};
